module.exports = __webpack_public_path__ + "static/assets/003bd86a7b63d3ddcf0e2608e728496d.svg";